<template>
    <div class="assemble-detail" v-if="page_show">
        <div class="swiper-box">
            <swiper>
                <swiper-slide v-for="(item,index) in product.img_path" :key="index"><img :src="item"></swiper-slide>
            </swiper>
        </div>
        <!-- 商品信息 -->
        <div class="info-box">
            <div>
                <span class="fs_24 c_main">¥</span>
                <span class="fs_36 c_main">{{product.price}}&nbsp;</span>
                <span class="fs_26 c_b3 line_through">¥{{product.price_original}}</span>
            </div>
            <div class="flex align-center timing-box">
                <span class="jcicon jcicon-miaosha fs_30 c_main"></span>
                <span class="fs_30 c_main" v-if="product.status==1">&ensp;距结束&ensp;</span>
                <span class="fs_30 c_main" v-else-if="product.status==2">&ensp;距开始&ensp;</span>
                <span class="fs_30 c_main" v-else>&ensp;已结束&ensp;</span>
                <div class="flex align-center">
                    <div class="timing-tips">
                        <span class="fs_28 c_ff">{{hour}}</span>
                    </div>
                    <span class="fs_28 c_1a">&ensp;时&ensp;</span>
                    <div class="timing-tips">
                        <span class="fs_28 c_ff">{{minute}}</span>
                    </div>
                    <span class="fs_28 c_1a">&ensp;分&ensp;</span>
                    <div class="timing-tips">
                        <span class="fs_28 c_ff">{{second}}</span>
                    </div>
                    <span class="fs_28 c_1a">&ensp;秒&ensp;</span>
                </div>
            </div>
            <p class="c_1a fs_32 lh_40 mt_20">{{product.name}}</p>
            <div class="mt_20">
                <span class="fs_24 c_98 lh_40">已拼{{product.sales}}份</span>
                <div class="share-box"  @click="share_show=!share_show">
                    <span class="jcicon jcicon-fenxiang1 fs_26 c_98"></span>
                    <span class="fs_24 c_98">分享</span>
                </div>
            </div>
        </div>

        <!-- 服务保障 -->
        <div class="flex__between__center publicity" v-if="attach_vic.length" @click="ensure_modal=true">
            <span class="fs_24 c_98 publicity__item ellipsis_one" v-for="(item,index) in attach_vic" :key="index">•&ensp;{{item.name}}</span>
            <span class="jcicon jcicon-jiantouarrow487 fs_26 c_98"></span>
        </div>
        
        <!-- 在开团 -->
        <div class="regiment-box" v-if="product.status==1&&group_total">
            <div class="flex__between__center regiment__header" v-link="'/Assemble/Regiment/'+product.id">
                <span class="fs_30 c_1a">{{group_total}}人在开团,可直接参与</span>
                <div>
                    <span class="fs_26 c_80">查看更多</span>
                    <span class="jcicon jcicon-jiantouarrow487 fs_26 c_98"></span>
                </div>
            </div>
            <div class="flex__between align-center regiment__item" v-for="(item,index) in group" :key="index">
                <div>
                    <img :src="item.headimgurl" alt="">
                    <span class="fs_28 c_4d">&ensp;{{item.nickname}}</span>
                </div>
                <div class="flex align-center">
                    <div class="flex__center__around">
                        <span class="fs_28 c_1a lh_40">还差 <span class="fs_28 c_main">{{item.rest_number}}人</span>成团</span>
                        <span class="fs_22 c_98 lh_30">剩余：{{item.hour}}:{{item.minute}}:{{item.second}}</span>
                    </div>
                    <button @click="show=!show;orders.order_type=2;orders.group_id=item.group_id;">去参团</button>
                </div>
            </div>
        </div>
        <!-- 已结束团 -->
        <div class="regiment-box" v-if="product.status==3&&group_finished.length">
            <div class="flex align-center regiment__header">
                <span class="fs_32 c_1a">参团小伙伴</span>
            </div>
            <div class="flex align-center regiment__item">
                <img :src="item.headimgurl" alt="" v-for="(item,index) in group_finished" :key="index">
                <img src="@/assets/images/group.png" alt="" v-if="group_finished_total==5">
            </div>
        </div>
        <!-- 评价 -->
        <div class="modular">
            <div class="modular__title">
                <span class="fs_36 c_1a fw_500">商品评价</span>
                <span class="fs_30 c_80">（{{review_total}}）</span>
            </div>
            <div class="evaluate__item" v-if="review.length">
                <div class="flex item__header">
                    <img :src="review[0].headimgurl" alt="">
                    <div class="flex__null__around ml_20">
                        <span class="fs_30 c_name">{{review[0].nickname}}</span>
                        <div> 
                            <span class="fs_26 c_98">{{review[0].create_time}}</span>
                            <span class="fs_26 c_98" v-if="review[0].product_sku_name">&emsp;规格:{{review[0].product_sku_name}}</span>
                        </div>
                    </div>
                </div>
                <p class="fs_30 c_1a mt_20 lh_40" v-if="review[0].content">{{review[0].content}}</p>
                <div class="flex wrap item__img mt_20" v-if="review[0].img_path.length">
                    <img :src="item" alt="" v-for="(item,index) in review[0].img_path" :key="index">
                </div>
            </div>
            <!-- <div class="flex align-center null-box" v-else>
                <p class="fs_28 c_1a">暂无评价</p>
            </div> -->
            <div class="flex__between__center modular__footer" v-link="'/Assemble/EvaluateList/'+product.id">
                <span class="fs_28 c_1a">查看全部评论</span>
                <span class="jcicon jcicon-jiantouarrow487 fs_30 c_98"></span>
            </div>
        </div>

        <!-- 详情 -->
        <div class="modular" v-if="product.description">
            <div class="modular__title">
                <span class="fs_36 c_1a fw_500">商品详情</span>
            </div>
            <div v-html="product.description" class="modular__content">{{product.description}}</div>
        </div>

        <!-- 保障modal -->
        <div v-show="ensure_modal" class="ensure-box">
            <div class="layer" @click="ensure_modal=false"></div>
            <div class="ensure">
                <div class="ensure__content">
                    <p class="flex__around fs_36 c_1a">服务保障</p>
                    <div class="flex ensure-item" v-for="(item,index) in attach" :key="index">
                        <img :src="item.icon" alt="">
                        <div class="flex__null__between ensure-item__right">
                            <span class="fs_28 c_4d">{{item.name}}</span>
                            <span class="fs_22 c_b3 mt_15">{{item.brief}}</span>
                        </div>
                    </div>
                </div>
                <button class="close-btn" @click="ensure_modal=false">关闭</button>
            </div>
        </div>
        <div class="flex__between footer">
            <div class="flex__center__around footer__left" @click='show=!show;orders.order_type =3'>
                <span class="fs_24 c_ff lh_50">¥<span class="fs_32">{{product.price}}</span></span>
                <span class="fs_32 c_ff lh_40">单独购买</span>
            </div>
            <div class="footer__right" @click='excessive'>
                <div class="btn-layer" v-if="product.status!=1"></div>
                <div class="flex__center__around footer__right__item">
                    <span class="fs_24 c_ff lh_50">¥<span class="fs_32">{{product.price_group}}</span></span>
                    <span class="fs_32 c_ff lh_40" v-if="product.status==1">立即开团</span>
                    <span class="fs_32 c_ff lh_40" v-else-if="product.status==2">等待开团中</span>
                    <span class="fs_32 c_ff lh_40" v-else>已结束</span>
                </div>
            </div>
        </div>

        <!-- 规格modal -->
        <div>
            <div class='layer' v-show='show' @click='show=!show'></div>
            <div class='model' v-show='show'>
                <div class='model__info'>
                    <img :src='product.cover_img'>
                    <div class='flex__null__between model__info__right'>
                        <div class='flex__between__center'>
                            <div>
                                <span class='fs_24 c_main'>¥</span>
                                <span class='fs_32 c_main'>{{product.price}}</span>
                            </div>
                            <span class='jcicon jcicon-error c_b3' @click='show=!show'></span>
                        </div> 
                        <span class='fs_24 c_98'>库存：{{product.stock}}</span>
                        <span v-if="product_spec.length" class='fs_24 c_98'>已选规格：{{sku_name}}</span>
                    </div>
                </div>
                <div class="model__spec-box">
                    <div class='model__spec' v-for="(item,index) in product_spec" :key="index ">
                        <span class='fs_28 c_33'>{{item.spec_title}}</span>
                        <div class='flex wrap '>
                            <div 
                            v-for="(item1,index1) in item.spec_item" 
                            :key="index1" 
                            @click="switchSpec(index,index1)">
                                <div class="model__spec__item" :class="[item1.active?'active':'',item1.apply?'actives':'']">{{item1.spec_item_value}}</div>
                            </div>
                        </div>
                    </div>
                    <div class='flex__between__center model__num'>
                        <span class='fs_28 c_33'>数量</span>
                        <div class='stepper_components'>
                            <div class='count' @click='reduce'>
                                <span class='jcicon jcicon-jianhaocu c_4d fs_22'></span>
                            </div>
                            <div class='count count--big'>
                                <span class='fs_24'>{{orders.number}}</span>
                            </div>
                            <div class='count' @click='add'>
                                <span class='jcicon jcicon-jiahao c_4d fs_22'></span>
                            </div>
                        </div>
                    </div>
                </div>

                <div class='model__footer' @click="sure">
                    <button>确定</button>
                </div>
            </div>
        </div>
        <!-- 浮层菜单 -->
        <back-top v-back-top v-scroll-show:800="is_top" :show="is_top.value" :url="'/Assemble/Index'"></back-top>
        <!-- 分享浮层 -->
        <share-layer :show_share="share_show" @isShow="isShow"></share-layer>
    </div>
</template>
<script>
export default {
    name: 'AssembleDetail',
    data(){
        return{
            page_show:false,// 页面展示优化
            share_show: false, //分享图层
            is_top:{value:false}, //返回顶部
            product:{
                img_path:[]
            },
            product_spec: [],
            attach:[],
            attach_vic: [],
            review_total: 0,
            review:[],
            group_total: 0,
            group:[],
            group_finished_total: 0,
            group_finished:[],
            ensure_modal: false,
            is_collect: 0,
            hour: '00',
            minute: '00',
            second: '00',
            orders:{
                number: 1,
                order_type:1,
                product_id: '',
                group_id: '',
                product_sku: ''
            },
            show: false, //规格modal
            sku_name: '请选择',
            sku_arr: [], //选中规格id数组
            interval:()=>{}
        }
    },
    methods:{
        // 分享图层
        isShow(data){
            this.share_show=data;
        },
        // 选择规格 (下级规格 往里面push)
        switchSpec(index,index1) {
            // 判断当前是否还有库存
            if (this.product_spec[index].spec_item[index1].apply) {
                this.$toast('库存不足');
                return;
            }

            let product_sku = this.product_sku;//匹配规格数据
            let product_spec = this.product_spec;//规格列表
            let sku_arr = this.sku_arr;//选中规格
            sku_arr[index] = product_spec[index].spec_item[index1];
            let chose_sku = sku_arr.concat();//选中规格id,副本
            // 选中或取消
            if (product_spec[index].spec_item[index1].active) {
                this.initial();
                // 取消 去掉样式
                product_spec[index].spec_item[index1].active = false;
                chose_sku.splice(index, 1,'');
                for(let i=0;i<chose_sku.length;i++){
                    if(chose_sku[i]){
                        this.proving(chose_sku[i].spec_item_id,res=>{
                            this.splitCheck(res,i);
                        }) 
                    }
                }
            } else {
                //清空当前行选中规格
                for (let i = 0; i < product_spec[index].spec_item.length; i++) {
                    product_spec[index].spec_item[i].active = false;
                }
                product_spec[index].spec_item[index1].active = true;
                this.proving(chose_sku[index].spec_item_id,res=>{
                    this.splitCheck(res,index);
                })  
            }

            let sku_code_str = ''; //副数组转为的字符串
            let chose_sku_vic=[];
            let chose_sku_name=[];
            let sku_name = '';//规格名称
            let product = this.product;
            let check_length=true;
            for(let i=0;i<chose_sku.length;i++){
                if(!chose_sku[i]){
                    check_length=false;
                    break;
                }
            }
            // 规格选全
            if (chose_sku.length == product_spec.length&&check_length) {
                for(let i=0;i<chose_sku.length;i++){
                    chose_sku_vic.push(chose_sku[i].spec_item_id);
                    chose_sku_name.push(chose_sku[i].spec_item_value);
                }
                sku_code_str=chose_sku_vic.sort().join('_');
                sku_name=chose_sku_name.join(',');
                for (let key in product_sku) {
                    if (key == sku_code_str) {
                        product.price = product_sku[key].price;
                        product.cover_img = product_sku[key].cover_img;
                        product.stock = product_sku[key].stock;
                        this.orders.product_sku = sku_code_str;
                    }
                }
            } else {
                product.price = this.product_vic.price;
                product.cover_img = this.product_vic.cover_img;
                sku_name = '请选择';
                product.stock = this.product_vic.stock;
                this.orders.product_sku = sku_code_str;
            }
            this.sku_arr=chose_sku;
            this.product_spec=product_spec;
            this.product=product;
            this.sku_name=sku_name;
        },
        // 初始
        initial(){
            let product_sku = this.product_sku;
            let being_sku = [];
            let being_item=[];
            for (let key in product_sku) {
                if (product_sku[key].stock) {
                    let item_str=[];
                    item_str = key.split('_');
                    for(let i=0;i<item_str.length;i++){
                        being_sku.push(item_str[i]);
                    }
                } 
            }
            for(let i=0;i<being_sku.length;i++){
                if(being_item.indexOf(being_sku[i]) == -1){
                    being_item.push(being_sku[i]);
                }
            }
            this.splitCheck(being_item);
        },
        // 返回有当前item_id的
        proving(spec_item_id, callback) {
            let product_sku = this.product_sku;
            let being_sku = [];
            let being_item=[];
            for (let key in product_sku) {
                if (key.indexOf(spec_item_id) != -1&&product_sku[key].stock) {
                    let item_str=[];
                    item_str = key.split('_');
                    for(let i=0;i<item_str.length;i++){
                        being_sku.push(item_str[i]);
                    }
                } 
            }
            for(let i=0;i<being_sku.length;i++){
                if(being_item.indexOf(being_sku[i]) == -1){
                    being_item.push(being_sku[i]);
                }
            }
            callback(being_item);
        },
        //拆分赋值
        splitCheck(being_item,index){
            let product_spec = this.product_spec;
            for (let i = 0; i < product_spec.length; i++) {
                if (i != index) {
                    for (let j = 0; j < product_spec[i].spec_item.length; j++) {
                        product_spec[i].spec_item[j].apply = true;
                    }
                }
            }
            for (let i = 0; i < product_spec.length; i++) {
                if (i != index) {
                    for (let j = 0; j < product_spec[i].spec_item.length; j++) {
                        for(let m = 0; m < being_item.length; m++){
                            if(being_item[m]==product_spec[i].spec_item[j].spec_item_id){
                                product_spec[i].spec_item[j].apply = false;
                                break;
                            }
                        }
                    }
                }
            }
        },
        // 对象深度克隆 
        cloneObj(obj){
            let str, newobj = obj.constructor === Array ? [] : {};
            if(typeof obj !== 'object'){
                return;
            } else if (JSON) {
                str = JSON.stringify(obj), //序列化对象
                newobj = JSON.parse(str); //还原
            } else {//如果不支持以上方法
                for (let i in obj) {
                    newobj[i] = typeof obj[i] === 'object' ? this.cloneObj(obj[i]) : obj[i];
                }
            }
            return newobj;
        },
        // 减
        reduce() {
            if (this.sku_arr.length != this.product_spec.length){
                this.$toast('请选择规格');
                return;
            }
            if (this.orders.number > 1) {
                this.orders.number=this.orders.number - 1;
            } else {
                this.$toast('不能再减了');
            }
        },
        // 加
        add() {
            if (this.sku_arr.length != this.product_spec.length) {
                this.$toast('请选择规格');
                return;
            }
            if (!this.product.stock) {
                this.orders.number=this.orders.number + 1;
            } else if (this.orders.number < this.product.stock) {
                this.orders.number=this.orders.number + 1;
            }else{
                this.orders.number=this.product.stock;
                this.$toast('库存不足' + this.product.stock);
            }
        },
        // 下单过度
        excessive(){
            if(this.product.status==1){
                this.show=!this.show;
                this.orders.order_type=1;
            }else if(this.product.status==2){
                this.$toast('等待开团中')
            }else{
                this.$toast('已结束')
            }
        },
        // 下单
        sure() {
            if (this.sku_arr.length != this.product_spec.length) {
                this.$toast('请选择规格');
                return;
            }
            // 团长开团
            if (this.orders.order_type == 1) {
                this.httpPost({
                    url:'/Collage/getOrderReady',
                    params:this.orders,
                    loading:1
                }).then(res => {
                    if (res.code == 1) {
                        this.$router.push({path:'/Assemble/Order',query: {
                            product_id:this.orders.product_id,
                            number:this.orders.number,
                            sku:this.orders.product_sku,
                            order_type:1}})
                    }else{
                        this.$toast(res.message);
                    }
                })
            } else if(this.orders.order_type == 2){
                // 参团
                this.httpPost({
                    url:'/Collage/getOrderReady',
                    params:this.orders,
                    loading:1
                }).then(res => {
                    if (res.code == 1) {
                        this.$router.push({path:'/Assemble/Order',query: {
                            product_id:this.orders.product_id,
                            number: this.orders.number,
                            sku:this.orders.product_sku,
                            group_id: this.orders.group_id,
                            order_type:2}})
                    }else{
                        this.$toast(res.message);
                    }
                })
            } else{ 
                // 单独购买
                this.httpPost({
                    url:'/Collage/getOrderReady',
                    params:this.orders,
                    loading:1
                }).then(res => {
                    if (res.code == 1) {
                        this.$router.push({path:'/Assemble/Order',query: {
                            product_id:this.orders.product_id,
                            number:this.orders.number,
                            sku:this.orders.product_sku,
                            order_type:3}})
                    }else{
                        this.$toast(res.message);
                    }
                })
            }
        },
        // 计算到计时
        countTime(time,interval_obj,callback){
            let current_time = Date.parse(new Date()) / 1000;
            var totalSecond = time - current_time;
            interval_obj = setInterval( ()=> {
                // 秒数
                var second = totalSecond;
                // 小时位
                var hr = Math.floor((second) / 3600);
                var hrStr = hr.toString();
                if (hrStr.length == 1) hrStr = '0' + hrStr;

                // 分钟位
                var min = Math.floor((second - hr * 3600) / 60);
                var minStr = min.toString();
                if (minStr.length == 1) minStr = '0' + minStr;

                // 秒位
                var sec = second - hr * 3600 - min * 60;
                var secStr = sec.toString();
                if (secStr.length == 1) secStr = '0' + secStr;
                    callback({
                        hrStr,
                        minStr,
                        secStr})
                    totalSecond--;
                if (totalSecond < 0) {
                    clearInterval(interval_obj);
                    this.$toast('活动已结束');
                    return{
                        hrStr:'00',
                        minStr:'00',
                        minStr:'00'
                    }
                }
            }, 1000);
        },
        // 查看大图
        previewImage(index){
            this.$wx.previewImage({
                url: this.review[0].img_path[index],
                urls: this.review[0].img_path
            })
        }
    },
    mounted(){
        this.httpPost({
            url:'/Collage/getProductDetailData',
            params:{product_id: this.$route.params.id},
            loading:1
        }).then(
            res=>{
                if(res.code==1){
                    this.page_show=true;
                    this.orders.product_id=res.data.product.id;
                    this.product_sku=res.data.product_sku;
                    this.product=res.data.product;
                    this.product_vic=this.cloneObj(res.data.product);
                    this.product_spec=res.data.product_spec;
                    this.attach=res.data.attach;
                    if(this.attach.length>4){
                        this.attach_vic=this.attach.concat().splice(0,4);
                    }else{
                        this.attach_vic=this.attach;
                    }
                    this.review_total=res.data.review_total;
                    this.review=res.data.review;
                    this.group_total=res.data.group_total;
                    this.group=res.data.group;
                    this.group_finished_total=res.data.group_finished_total;
                    this.group_finished=res.data.group_finished;
                    this.is_collect=res.data.is_collect;
                    this.product.description=res.data.product.description.replace(/\<img/gi, '<img style="max-width:100%;height:auto" ');
                    
                    for(let i=0;i<this.group.length;i++){
                        this.countTime(this.group[i].end_time,this.group[i].interval,time_res=>{
                            this.$set(this.group[i],'hour',time_res.hrStr);
                            this.$set(this.group[i],'minute',time_res.minStr);
                            this.$set(this.group[i],'second',time_res.secStr);
                        });
                    }
                    // 倒计时
                    if(this.product.status!=3){
                        if(this.product.status==1){
                            this.countTime(this.product.activity_end_time,this.interval,time_res=>{
                                this.hour=time_res.hrStr;
                                this.minute=time_res.minStr;
                                this.second=time_res.secStr;
                            });
                            
                        }else{
                            this.countTime(this.product.activity_start_time,this.interval,time_res=>{
                                this.hour=time_res.hrStr;
                                this.minute=time_res.minStr;
                                this.second=time_res.secStr;
                            });
                        }
                    }

                    this.$wx.setConfig()
                    // 分享欲配置
                    this.$wx.share({
                        title: this.product.name,
                        desc: this.product.name,
                        link:"https://ym.jucheng01.net/vue/Assemble/Detail/"+this.product.id,
                        imgUrl: this.product.cover_img 
                    })
                }
            }
        )
    },
    destroyed(){
        console.log(this.interval);
        clearInterval(this.interval);
        for(let i=0;i<this.group.length;i++){
            clearInterval(this.group[i].interval);
        }
    }
}
</script>

<style scoped>
.swiper-box img{
    width:750px;
    height:600px;
}
.info-box{
    position: relative;
    padding: 25px 30px 25px;
    background: #fff;
}
/* 倒计时 */
.timing-box{
    height: 80px;
    padding: 0 15px;
    margin-top: 20px;
    background: #FAF2ED;
}
.timing-tips{
    min-width: 48px;
    height: 48px;
    padding: 0 8px;
    background: #1a1a1a;
    border-radius:6px;
    text-align: center;
    line-height: 48px;
}
.publicity{
    height: 80px;
    padding: 0 30px;
    border-top: 2px solid #e6e6e6;
    background: #fff;
}
.publicity__item{
    width: 150px;
}
.share-box{
    position: absolute;
    bottom: 25px;
    right: 0;
    padding: 0 20px;
    height: 50px;
    line-height: 40px;
    border-radius: 25px 0 0 25px;
    background: #f0f0f0;
}
/* 模块 */
.modular{
    margin-top: 15px;
    padding: 0 30px 0;
    background: #fff;
}
.modular__title{
    padding: 30px 0;
}
.modular__content{
    padding-bottom:30px;
}
.evaluate__item{
    padding-bottom: 30px;
}
.item__header img{
    width: 80px;
    height: 80px;
    border-radius: 50%;
}
.item__img img{
    width: 165px;
    height: 165px;
    margin: 10px 0 0 10px;
}
.item__img img:nth-child(4n+1){
    margin-left: 0;
}
.item__reply{
    padding: 10px 20px;
    background: #f5f5f5;
    border-radius: 10px;
}
.modular__footer{
    height: 90px;
    border-top: 2px solid #e6e6e6;
}
.null-box{
    border-top: 2px solid #e6e6e6;
    height: 90px;
}

/* 拼团 */
.regiment-box{
    margin-top: 15px;
    background: #fff;
}
.regiment__header{
    height: 100px;
    padding: 0 30px;
    border-bottom: 2px solid #e6e6e6;
}
.regiment__item{
    height: 130px;
    padding: 0 30px;
}
.regiment__item button{
    width:130px;
    height:60px;
    margin-left: 30px;
    border-radius:4px;
    background: #F93A42;
    font-size: 28px;
    color: #fff;
}
.regiment__item img{
    width: 70px;
    height: 70px;
    border-radius: 50%;
}

/* modal */
.layer{
    position: fixed;
    top: 0;
    bottom: 0;
    width: 100%;
    background: rgba(0,0,0,0.6);
    z-index: 2;
}
.ensure{
    position: fixed;
    bottom: 0;
    width: 100%;
    height: auto;
    z-index: 3;
    background: #fff;
}
.ensure__content{
    padding: 30px;
}
.ensure-item{
    padding: 30px 0;
    border-top: 2px solid #e6e6e6;
}
.ensure-item:nth-child(2){
    border: 0;
}
.ensure-item img{
    width: 60px;
    height: 60px;
    border-radius: 50%;
}
.ensure-item__right{
    margin-left: 20px;
}
.close-btn{
    width: 100%;
    height: 98px;
    background: #F93A42;
    color: #fff;
    font-size: 32px;
}
.footer{
    position: fixed;
    bottom: 0;
    width: 100%;
    height: 98px;
    z-index: 1;
}
.footer__left,.footer__right{
    width: 50%;
    height: 98px;
}
.footer__left{
    background: #333;
}
.footer__right{
    position: relative;
    background: #F93A42;
}
.footer__right__item{
    position: absolute;
    width: 100%;
    height: 98px;
}
.btn-layer{
    position: absolute;
    width: 100%;
    height: 98px;
    background: #fff;
    opacity: 0.6;
}

/* 规格model */
.model{
  position: fixed;
  bottom: 0;
  z-index: 3;
  width: 100%;
  background: #fff;
}
.model__info{
  display: flex;
  padding: 30px 30px 0;
}
.model__info img{
  display: block;
  width: 220px;
  height: 220px;
  margin-top: -60px;
  border: 2px solid #E6E6E6;
  border-radius: 10px;
  background: #fff;
}
.model__info__right{
  width: 440px;
  margin-left: 30px;
}
.size-table{
  width: 120px;
  height: 30px;
  background: #1a1a1a;
  line-height: 30px;
}
.model__spec-box{
    max-height: 700px;
    padding: 0 30px;
    margin: 10px 0;
    overflow: auto;
}
.model__spec{
  padding: 30px 0;
  border-bottom: 2px solid #e6e6e6;
}
.model__spec__item{
    min-width: 60px;
    margin: 20px 20px 0 0;
    padding: 0 20px;
    height: 60px;
    line-height: 56px;
    text-align: center;
    font-size: 26px;
    color: #989898;
    border: 2px solid #CBCBCB;
    border-radius: 6px;
}
.active{
    color: #F93A42;
    border: 2px solid #F93A42;
}
.actives{
    background: #e8e8e8;
    color: #c8c9cc;
    border: none;
}
.model__num{
    height: 120px;
}
/* 计步器 */
.stepper_components{
    display: flex;
    justify-content: space-between;
    width: 200px;
    border: 2px solid #e6e6e6;
}
.stepper_components .count{
    width: 66px;
    height: 60px;
    line-height: 60px;
    text-align: center;
}
.stepper_components .count--big{
    width: 85px;
    height: 60px;  
    border-right: 2px solid #e6e6e6;
    border-left: 2px solid #e6e6e6;
    text-align: center;
}
.model__footer button{
    width: 100%;
    height: 98px;
    line-height: 98px;
    font-size: 32px;
    background: #F93A42;
    color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/pages/assemble/Detail.vue